module.exports = __webpack_public_path__ + "img/minus.8935ddbd.svg";